import React from "react";
import { ProgressBar } from "primereact/progressbar";
import PropTypes from "prop-types";
import "./conversations.scss";
import AttachmentIcon from "./AttachmentIcon";
import CustomeButton from "../../Button";
import ErrorMessage from "./ErrorMessage";
import { FileUpload } from "primereact/fileupload";
import { getDocumentLabel, formatFileSize } from "~/utils/fileUtils";
import DocumentDescription from "~/components/document-description";
import { useParams } from "react-router-dom";

const CommentsAttachments = ({
  file,
  fileHandler,
  progressBar,
  icon,
  error = false,
  handleErrorVisibility = () => {},
  getFileSizeMB = () => {},
  handleReplace = () => {},
  label,
  size,
  relatedType = "",
  displayName = "",
}) => {
  const { id } = useParams();
  const fileNameToDisplay =
    displayName || file?.metadata?.display_name || file?.fileName || file?.name;
  const fileType = getDocumentLabel(fileNameToDisplay);
  const fileSize = formatFileSize(file?.size || 0);
  return (
    <div className="attachment mt-2">
      <div className="attachment__file">
        <div className="file-content">
          <div className="icon-container">
            <AttachmentIcon file={file} />
          </div>
          <div className="file-details">
            <p className="comment-file-name">{`${fileNameToDisplay}`}</p>
            <div className="flex gap-2 text-xs text-color-secondary">
              <span>{fileType}</span>
              <span>File size: {fileSize}</span>
            </div>
            {(label || size) && (
              <p className="file-label">
                {label && <span>{label + ". "}</span>}
                {size && <span>{`File Size: ${size}`}</span>}
              </p>
            )}

            <div></div>
            {progressBar && (
              <ProgressBar
                value={40}
                mode="indeterminate"
                color="#188A42"
                showValue={false}
              ></ProgressBar>
            )}
          </div>
        </div>
        {error.state && (
          <div className="attachment__file--actions">
            <CustomeButton
              label="Remove"
              variant="remove"
              className="access-btn"
              onClick={fileHandler}
            />
            {getFileSizeMB(file) < 20 && (
              <div className="replase__btn">
                <FileUpload
                  name="replace-file"
                  customUpload={true}
                  onSelect={(newFile) => handleReplace(newFile, file)}
                  chooseOptions={{
                    label: "Replace",
                    className: "attachment-button  p-button-outlined ",
                  }}
                  mode="advanced"
                />
              </div>
            )}
          </div>
        )}
        {!error.state && (
          <>
            <div className="mx-2">
              <DocumentDescription data={file} id={id} type={relatedType} />
            </div>
            <i className={`pi ${icon} action-icon`} onClick={fileHandler} />
          </>
        )}
      </div>
      {error.visible && error.state && (
        <ErrorMessage
          summary={
            getFileSizeMB(file) > 20
              ? "File Exceeds Size Limit"
              : "Unsupported File"
          }
          detail={
            getFileSizeMB(file) > 20
              ? "This file exceeds the maximum size limit. Please upload a smaller file"
              : "This file type is not supported. Please upload a valid file format."
          }
          handleClose={handleErrorVisibility}
        />
      )}
    </div>
  );
};

CommentsAttachments.propTypes = {
  file: PropTypes.file,
  fileHandler: PropTypes.func,
  progressBar: PropTypes.bool,
  icon: PropTypes.string,
  error: PropTypes.bool,
  handleErrorVisibility: PropTypes.func,
  getFileSizeMB: PropTypes.func,
  showerror: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.string,
  displayName: PropTypes.string,
};

export default CommentsAttachments;
